<template>
  <b-card no-body>
    <b-card-header><b-card-title>Profiel</b-card-title></b-card-header>
    <b-card-body>
      <b-list-group v-if="profiel">
        <b-list-group-item 
          v-for="(value,key) in profiel.auth" 
          :key="key"
        >
          {{ key }} : {{ value }}
        </b-list-group-item>
      </b-list-group>
    </b-card-body>
    <b-card-footer />
  </b-card>
</template>
<script>
import { serviceMixin } from '@/mixins/serviceMixin';

export default {
  name: "Authenticatie",
  mixins: [serviceMixin],
  data() {
    return {
      profiel: null
    };
  },
  mounted() {
    this.getProfile()
  },
  methods: {
    getProfile() {
      var vm = this;
      this.get("/user/profile")
        .then(function(response) {
          vm.profiel = response.data;
        })
        .catch(function(error) {
          vm.profiel = error;
        });
    }
  }
};
</script>